function positiveIntegerOrNull(value) {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}

export function resolveCurrentWorkItemAttemptId(item = {}) {
  const explicitId = [
    item.current_attempt_id,
    item.currentAttemptId,
    item.current_attempt?.id,
    item.attempt_id,
  ].map(positiveIntegerOrNull).find(Boolean)
  if (explicitId) return explicitId

  const openAttempts = (Array.isArray(item.attempts) ? item.attempts : [])
    .filter(attempt => String(attempt?.status || '').toLowerCase() === 'open')
    .map(attempt => ({
      id: positiveIntegerOrNull(attempt?.id),
      attemptNo: Number(attempt?.attempt_no) || 0,
    }))
    .filter(attempt => attempt.id)
    .sort((left, right) => right.attemptNo - left.attemptNo || right.id - left.id)

  return openAttempts[0]?.id ?? null
}

export function requireCurrentWorkItemAttemptId(item = {}) {
  const attemptId = resolveCurrentWorkItemAttemptId(item)
  if (!attemptId) throw new TypeError('open attempt ID를 확인해 주세요.')
  return attemptId
}

export function isRuntimeBranchWorkItem(item = {}) {
  const branchId = item.branch_instance_id ??
    item.branch_id ??
    item.extra_fields?.runtime_branch_id ??
    item.metadata?.runtime_branch_id
  return branchId !== undefined && branchId !== null && branchId !== ''
}

function buildWorkItemAttemptMutationContext(item = {}) {
  const treeVersion = Number(item.work?.tree_version ?? item.tree_version)
  if (!Number.isInteger(treeVersion) || treeVersion < 1) {
    throw new TypeError('Work tree version을 확인해 주세요.')
  }
  const context = { expected_tree_version: treeVersion }
  if (isRuntimeBranchWorkItem(item)) {
    context.work_item_attempt_id = requireCurrentWorkItemAttemptId(item)
  }
  return context
}

export function buildWorkItemManualInputContext(item = {}) {
  return buildWorkItemAttemptMutationContext(item)
}

export function buildWorkItemStatusContext(item = {}) {
  return buildWorkItemAttemptMutationContext(item)
}

export function workItemAttemptMutationRequiresRefresh(errorCode) {
  return [
    'RUNTIME_BRANCH_ATTEMPT_REQUIRED',
    'RUNTIME_BRANCH_ATTEMPT_CONFLICT',
  ].includes(String(errorCode || ''))
}
